export default __webpack_public_path__ + "static/favicon-2f1d3b2f78b151962fbb93cf439c5b5b.jpg";